import { Button, ButtonGroup, DialogBody, DialogContainer, DialogFooter, DialogHeader, LineClamp, MemberName } from "@wg/wows-react-uikit"
import TooltipBody from "@wg/wows-react-uikit/TooltipBody"
import DivTooltip from "@wg/wows-react-uikit/DivTooltip"
import uniqueId from "lodash/uniqueId"
import * as React from "react"
import styles from "./MembersOperationDialog.scss"

const TOOLTIP_LINES_COUNT = 20
export interface MembersOperationDialogProps {
  buttonActionTitle: string,
  buttonCloseTitle: string,
  controlElement: React.ReactNode,
  membersForOperate: Array<any>,
  spinnerLabel: string,
  textAfterMembers: string,
  textBeforeMembers: string,
  title: string,

  buttonActionDisabled: boolean,

  onActionClick: () => void,
  onCloseClick: () => void
}

export interface MembersOperationDialogState {
  isLoading: boolean,
  uniquePrefix: string
}

class MembersOperationDialog extends React.PureComponent<MembersOperationDialogProps, MembersOperationDialogState> {

  state = {
    isLoading: false,
    uniquePrefix: uniqueId('members_operation_dialog_')
  }

  onActionClick = () => {
    this.setState({
      isLoading: true
    })
    Promise.resolve(this.props.onActionClick()).then(this.stopLoading, this.stopLoading)
  }

  stopLoading = () => {
    this.setState({
      isLoading: false
    })
  }

  renderMembers() {
    const members = this.props.membersForOperate.map(member => <MemberName key={member.id} role={member.roleName} name={member.name} />)
    const needTooltip = this.props.membersForOperate.length > 10
    const tooltip = needTooltip ? (
      <TooltipBody>
        <LineClamp lines={TOOLTIP_LINES_COUNT}>{members}</LineClamp>
      </TooltipBody>
    ) : null

    const membersHtml = needTooltip ? null : <div className={styles.members} key={`${this.state.uniquePrefix}_members_html`}>
      {members}
    </div>

    let textBeforeMembers = null

    if (this.props.textBeforeMembers || needTooltip) {
      textBeforeMembers = (
        <div className={styles.title} key={`${this.state.uniquePrefix}_text_before_members`}>
          {this.props.textBeforeMembers}
          {needTooltip ? ` ${this.props.membersForOperate.length}` : null}
        </div>
      )
    }

    return (
      <DivTooltip
        tooltipBody={tooltip}
      >
        {textBeforeMembers}
        {membersHtml}
      </DivTooltip>
    )
  }

  render() {
    const controlElement = this.props.controlElement ? <div className={styles.select}>{this.props.controlElement}</div> : null
    const textAfterMembers = this.props.textAfterMembers ? <div className={styles.title}>{this.props.textAfterMembers}</div> : null

    return (
      <DialogContainer>
        <DialogHeader>{this.props.title}</DialogHeader>
        <DialogBody>
          <div className={styles.center}>
            {this.renderMembers()}
            {textAfterMembers}
            {controlElement}
          </div>
        </DialogBody>
        <DialogFooter>
          <ButtonGroup isLoading={this.state.isLoading} spinnerLabel={this.state.isLoading ? this.props.spinnerLabel : null}>
            <Button key="members-operation-dialog-action-button" isJustified isHighlighted onClick={this.onActionClick} isDisabled={!!this.props.buttonActionDisabled}>
              {this.props.buttonActionTitle}
            </Button>
            <Button key="members-operation-dialog-close-button" isJustified onClick={this.props.onCloseClick}>
              {this.props.buttonCloseTitle}
            </Button>
          </ButtonGroup>
        </DialogFooter>
      </DialogContainer>
    )
  }
}

export default MembersOperationDialog